import React from "react";
import { useTranslation } from "react-i18next";
import { FileQuestion } from "lucide-react";
import { Card } from "@guardian/shared-ui";

export const FormNotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md p-8 space-y-8">
        <div className="flex flex-col items-center space-y-6 text-center">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center">
            <FileQuestion className="w-8 h-8 text-muted-foreground" />
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl font-bold tracking-tight">
              {t("formNotFound.title")}
            </h1>
            <p className="text-muted-foreground">
              {t("formNotFound.description")}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};
